import { RootState } from '../rootReducer';
import { Env } from './actions';

export const getEnvState = (state: RootState): Env => state.env;
export const getIsAndroid = (state: RootState): boolean => state.env.isAndroid ?? false;
export const getIsIOS = (state: RootState): boolean => state.env.isIOS ?? false;
